<template>
  <div class="list-thumbnail flex-shrink-0 rounded overflow-hidden bg-light" :style="dimensions">
    <img
      v-if="imageSrc"
      :key="imageSrc"
      :src="imageSrc"
      :width="width"
      :height="height"
      loading="lazy"
      decoding="async"
      alt=""
      @error="onImageError"
    />
    <span v-else class="d-flex align-items-center justify-content-center h-100 text-muted" aria-hidden="true">
      <i class="bi-image" />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    fallbackSrc: String,
    width: { type: Number, default: 64 },
    height: { type: Number, default: 64 }
  },
  data: () => ({ failedSources: [] }),
  watch: {
    src() { this.failedSources = []; },
    fallbackSrc() { this.failedSources = []; }
  },
  computed: {
    imageSrc() { return [this.src, this.fallbackSrc].find(src => src && !this.failedSources.includes(src)); },
    dimensions() { return { width: `${this.width}px`, height: `${this.height}px` }; }
  },
  methods: {
    onImageError(event) {
      // An old image can finish failing after the row has received a new URL.
      const src = event.target.getAttribute('src');
      if (src && !this.failedSources.includes(src)) this.failedSources.push(src);
    }
  }
};
</script>

<style scoped>
.list-thumbnail img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
